<!-- Main change-password card -->
<article class="auth-card" *ngIf="!isVerifing; else VerificationModal">
  <div class="auth-content">
    <!-- Header -->
    <header class="card-header">
      <h1>CAMBIAR CONTRASEÑA</h1>
      <p>{{ deliveryInstruction }}</p>
    </header>

    <!-- Form -->
    <form action="post" [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()" class="auth-form" novalidate>
      <div class="alert-span-exeption" aria-live="polite">
        <span *ngIf="exceptionMessage != ''" [@inOutAnimation] class="error-message">{{ exceptionMessage }}</span>
      </div>

      <div class="form-field">
        <label for="code">Código de verificación</label>
        <div class="otp-field-container">
          <app-otp-input
            [otpLength]="6"
            (otpChange)="onOtpChange($event)"
          ></app-otp-input>
        </div>
      </div>

      <div class="alert-span" *ngIf="changePasswordFormValidation['code'].touched && changePasswordFormValidation['code'].invalid">
        <label class="error-message" *ngIf="changePasswordFormValidation['code'].errors && changePasswordFormValidation['code'].errors['required']" [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message" *ngIf="changePasswordFormValidation['code'].errors && changePasswordFormValidation['code'].errors['pattern']" [@inOutAnimation]>
          Formato de código incorrecto
        </label>
      </div>

      <div class="form-field">
        <label for="givenPassword">Nueva contraseña</label>
        <div class="password-input">
          <input
            id="givenPassword"
            [type]="isPasswordVisible ? 'text':'password'"
            name="password"
            placeholder="Tu contraseña"
            class="textInput"
            formControlName="givenPassword"
            autocomplete="new-password"
            (focus)="exceptionMessage = ''"
          >
          <i
            class="password-icon"
            [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"
            (click)="isPasswordVisible = !isPasswordVisible"
          ></i>
        </div>
      </div>

      <div class="alert-span" *ngIf="changePasswordFormValidation['givenPassword'].touched && changePasswordFormValidation['givenPassword'].invalid">
        <label class="error-message" *ngIf="changePasswordFormValidation['givenPassword'].touched && changePasswordFormValidation['givenPassword'].errors && changePasswordFormValidation['givenPassword'].errors['required']" [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message" *ngIf="changePasswordFormValidation['givenPassword'].touched && changePasswordFormValidation['givenPassword'].errors && changePasswordFormValidation['givenPassword'].errors['pattern']" [@inOutAnimation]>
          Formato incorrecto
        </label>
      </div>

      <div class="alert-span password-requirements">
        <span>La contraseña debe contener:</span>
        <ul>
          <li><span>Una longitud de 8 a 16 carácteres</span></li>
          <li><span>Al menos una letra en mayúscula</span></li>
          <li><span>Al menos una letra en minúscula</span></li>
          <li><span>Un número</span></li>
        </ul>
      </div>

      <div class="form-field">
        <label for="confirmGivenPassword">Confirmar contraseña</label>
        <div class="password-input">
          <input
            id="confirmGivenPassword"
            [type]="isConfirmPasswordVisible ? 'text':'password'"
            name="confirmPassword"
            placeholder="Confirma tu contraseña"
            class="textInput"
            formControlName="confirmGivenPassword"
            autocomplete="new-password"
            (focus)="exceptionMessage = ''"
          >
          <i
            class="password-icon"
            [ngClass]="isConfirmPasswordVisible ? 'hide-password' : 'show-password'"
            (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible"
          ></i>
        </div>
      </div>

      <div class="alert-span" *ngIf="changePasswordFormValidation['confirmGivenPassword'].touched && changePasswordFormValidation['confirmGivenPassword'].invalid">
        <label class="error-message" *ngIf="changePasswordFormValidation['confirmGivenPassword'].errors && changePasswordFormValidation['confirmGivenPassword'].errors['required']" [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message" *ngIf="changePasswordFormValidation['confirmGivenPassword'].errors && changePasswordFormValidation['confirmGivenPassword'].errors['matching']" [@inOutAnimation]>
          Las contraseñas no coinciden
        </label>
      </div>

      <!-- Actions -->
      <div class="form-buttons d-flex-column">
        <button type="submit" [disabled]="changePasswordForm.invalid || !isOtpComplete" class="submit-btn">Confirmar</button>
      </div>
    </form>
  </div>
</article>

<!-- Success state -->
<ng-template #VerificationModal>
  <article class="auth-card" [@inOutAnimation]>
    <div class="auth-content auth-success">
      <header class="card-header">
        <h1>CAMBIAR CONTRASEÑA</h1>
        <p>Se ha realizado el cambio de contraseña. <strong>Inicie sesión con su nueva contraseña.</strong></p>
      </header>
      <div class="form-buttons d-flex-column">
        <button type="button" class="submit-btn" (click)="goToLogin()">Iniciar sesión</button>
      </div>
    </div>
  </article>
</ng-template>
